module.exports = __webpack_public_path__ + "img/04-pic-R.e129ec9e.png";